import { Component, Input, OnInit } from '@angular/core';
import { Msisdn } from 'app/shared/msisdn/msisdns';
import { MatSelectChange } from '@angular/material';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-msisdn-dropdown',
  templateUrl: './msisdn-dropdown.component.html',
  styleUrls: ['./msisdn-dropdown.component.scss']
})
export class MsisdnDropdownComponent implements OnInit {
  @Input() msisdns: Msisdn[] = [];
  @Input() controlName: string;
  @Input() placeholder: string;
  @Input() form: FormGroup;
  @Input() firstItemDefault = false;

  selectedMsisdn: Msisdn;

  constructor() {}

  ngOnInit() {
    this.form.get(this.controlName).valueChanges.subscribe(id => {
      this.selectedMsisdn = this.getSelectedMsisdn(id);
    });
    this.selectedMsisdn = this.getSelectedMsisdn(this.form.get(this.controlName).value);
  }

  private getSelectedMsisdn(id: number): Msisdn {
    const selected = this.msisdns.find(msisdn => msisdn.id === id);
    if (!selected && this.firstItemDefault) {
      const msisdn = this.msisdns[0];
      this.form.get(this.controlName).setValue(msisdn.id);
      return msisdn;
    }
    return selected;
  }
}
